import React, { useRef, useState } from 'react'
import { Flex } from 'rebass'
import Text from 'particles/Text'
import { GridColumnHeaderParams } from '@mui/x-data-grid-pro'
import styled from 'particles/themes/styled'
import Tooltip from 'particles/Tooltip'
import { isOverflown } from 'particles/utils'
export const getStepDataHeaderCell = (splitter: string) =>
    function StepDataHeaderCell(params: GridColumnHeaderParams) {
        const { headerName = '' } = params.colDef
        const [taskTitle, ...rest] = headerName.split(splitter)
        const title = rest.join(splitter)
        const titleRef = useRef<HTMLDivElement>(null)
        const subtitleRef = useRef<HTMLDivElement>(null)
        const [showTaskTitleTooltip, setShowTaskTitleTooltip] = useState(false)
        const [showTaskTooltip, setShowTaskTooltip] = useState(false)

        const handleTitleMouseEnter = () => {
            const isTitleOverflown = titleRef.current ? isOverflown(titleRef.current) : false
            setShowTaskTitleTooltip(isTitleOverflown)
        }

        const handleSubtitleMouseEnter = () => {
            const isSubtitleOverflown = subtitleRef.current ? isOverflown(subtitleRef.current) : false
            setShowTaskTooltip(isSubtitleOverflown)
        }

        return (
            <Flex flexWrap="wrap" width={'100%'} minWidth={'100px'}>
                <Tooltip title={taskTitle} label={title} open={showTaskTitleTooltip}>
                    <StyledText
                        scale="bodyS700"
                        ref={titleRef}
                        onMouseEnter={handleTitleMouseEnter}
                        onMouseLeave={() => setShowTaskTitleTooltip(false)}
                    >
                        {taskTitle}
                    </StyledText>
                </Tooltip>
                <Tooltip title={taskTitle} label={title} open={showTaskTooltip}>
                    <StyledText
                        scale="bodyS500"
                        ref={subtitleRef}
                        onMouseEnter={handleSubtitleMouseEnter}
                        onMouseLeave={() => setShowTaskTooltip(false)}
                    >
                        {title}
                    </StyledText>
                </Tooltip>
            </Flex>
        )
    }

const StyledText = styled(Text)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    color: inherit;
`
